// Forks should change this.
// This can be accessed externally on `vm.runtime.platform`

module.exports = {
    name: 'TurboWarp',
    url: 'https://turbowarp.org/'
};
